import React from 'react';
import shopifyLogo from './assets/shopify_logo.png';
import chewyLogo from './assets/chewy_logo.png';
import adidasLogo from './assets/adidas_logo.png';
import jhuLogo from './assets/jhu_logo.png';
import jpmLogo from './assets/jpm_logo.png';

export default function SocialProofLogos(): JSX.Element {
  return (
    <>
      <img className="shopify-logo" alt="Shopify" src={shopifyLogo} />
      <img className="chewy-logo" alt="Chewy" src={chewyLogo} />
      <img className="adidas-logo" alt="Adidas" src={adidasLogo} />
      <img className="jpm-logo" alt="JP Morgan Chase & Co" src={jpmLogo} />
      <img className="jhu-logo" alt="Johns Hopkins University" src={jhuLogo} />
    </>
  );
}
